import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { ArcElement, Chart, ChartConfiguration, ChartData, DoughnutController } from 'chart.js';
import { BaseChartDirective } from 'ng2-charts';
import { AlertComponent } from '../../alert/alert.component';

export interface DonutChartLegend {
  colour: string;
  title: string;
  value: string;
}

export interface DonutChart {
  title: string;
  labels: string[];
  datasets: [{ data: number[]; backgroundColor: string[] }];
  legend?: DonutChartLegend[];
}

Chart.register(DoughnutController, ArcElement);

@Component({
  selector: 'ui-donut-chart',
  templateUrl: './donut-chart.component.html',
  styleUrl: './donut-chart.component.scss',
  standalone: true,
  imports: [CommonModule, BaseChartDirective, AlertComponent],
})
export class DonutChartComponent implements OnInit {
  @Input() chart: DonutChart | undefined;

  chartData: ChartData<'doughnut'> | undefined;
  chartOptions: ChartConfiguration<'doughnut'>['options'] | undefined;

  ngOnInit() {
    this.getChartOptions();
  }

  getChartOptions() {
    if (this.chart && this.chart.datasets) {
      this.chartOptions = {
        responsive: false,
        cutout: 90,
        spacing: 2,
        plugins: {
          legend: {
            position: 'left',
            display: false,
          },
        },
      };

      this.chartData = this.chart;
    }
  }
}
